import React from 'react';
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { Footer } from '../../Components/Footer/FooterComponent';
import { PremiosComponent } from '../../Components/Galeria/PremiosComponent';

export const Premios = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n}/>
            <NavMobile I18n={props.I18n}/>
            <PremiosComponent Data={props.Data} I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    );
};

